export {
  compileToAst,
  defineQueryFilters,
  queryStateFrom,
} from './compile';
export type {
  PropertyFilter,
  Query,
  QueryState,
} from './types';

export const NIL_UUID = '00000000-0000-0000-0000-000000000000';
